import React, {Component} from 'react'
import {Icon, Item, Step} from 'semantic-ui-react'
import PropTypes from 'prop-types'
import './form_path.css'

export default class FormPath extends Component {
    constructor(props) {
        super(props);
        this.state = {
            "processedGroups": this.processProps(props)
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.path !== nextProps.path ||
            this.props.currentItem !== nextProps.currentItem ||
            this.props.items !== nextProps.items ||
            this.props.canFreelyNavigate !== nextProps.canFreelyNavigate ||
            nextState !== this.state;
    }

    navigate = (pathItem) => {
        this.props.onNavigate({pathItem});
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({"processedGroups": this.processProps(this.props)})
        }
    }

    render() {

        let {currentItem, items, path, canFreelyNavigate} = this.props;
        const {processedGroups} = this.state;
        let previousGroup = "none";
        let nextPreviousGroup = previousGroup;
        let foundCurrent = false;
        return (
            <Step.Group size={"mini"} vertical id="form-path">
                {
                    path.map((pathItem, keyIndex) => {
                        const item = items[pathItem.itemId];
                        if (item === undefined) return <React.Fragment key={keyIndex}/>;
                        previousGroup = nextPreviousGroup;
                        const groupName = pathItem.group;
                        nextPreviousGroup = groupName;
                        const collapsed = processedGroups[groupName]?.collapsed;
                        const icon = groupName && collapsed ? 'angle down' : 'angle up';
                        const isCurrentItem = item.id === currentItem.id && item.group === groupName;
                        foundCurrent = foundCurrent || isCurrentItem;
                        if (!canFreelyNavigate && !isCurrentItem && foundCurrent) {
                            return null;
                        }
                        return (
                            <React.Fragment key={"formPath-" + keyIndex}>
                                {groupName && groupName !== previousGroup && (
                                    <Step className={"step-group"} active={false}
                                          completed={true}
                                          key={groupName + keyIndex + "-group"}>
                                        <Step.Content> <Step.Title style={{cursor: 'pointer'}} onClick={() => {
                                            this.toggleGroup(groupName, processedGroups)
                                        }}>{groupName} <Icon className={"collapse-icon"}
                                                             name={icon}/></Step.Title></Step.Content>
                                    </Step>)}
                                {(!groupName || collapsed === false) &&
                                <Step onClick={() => {
                                    this.navigate(pathItem)
                                }}
                                      active={isCurrentItem}
                                      completed={!isCurrentItem}>
                                    {/*<Icon name='check'/>*/}
                                    <Step.Content> <Step.Title>{item.title}</Step.Title></Step.Content>
                                </Step>}
                            </React.Fragment>
                        );
                    })
                }
            </Step.Group>

        )
    }

    processProps(props) {
        // process props to identify groups and items
        let {currentItem, path} = props;
        let previousGroup = "none";
        let nextPreviousGroup = previousGroup;
        const groups = {};
        for (let i = 0; i < path.length; i++) {
            const itemId = path[i].itemId;
            previousGroup = nextPreviousGroup;
            const groupName = path[i].group;
            nextPreviousGroup = groupName;
            if (groupName && groupName !== previousGroup) {
                groups[groupName] = {collapsed: true};
            }
            if (itemId === currentItem.id && groupName) {
                // we found currentItem
                // we mark all previous groups as collapsed
                groups[groupName].collapsed = false;
            }
        }
        return groups;
    }

    toggleGroup(groupName) {
        const collapsed = !this.state.processedGroups[groupName].collapsed;
        this.setState({
            processedGroups: {
                ...this.state.processedGroups,
                [groupName]: {...this.state.processedGroups[groupName], collapsed}
            }
        })
    }
}

Item.propTypes = {
    currentItem: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired,
    onNavigate: PropTypes.func.isRequired
};

